export enum AppRoute {
  ROOT = '/',
  LOGIN_PAGE = '/login',
  MASTER_KEY_SETTINGS_PAGE = '/master-key-settings',
  FILE_SYSTEM_SETTINGS_PAGE = '/file-system',
  ADS_SETTINGS_PAGE = '/ads-settings',
  CASINO_ADS_SETTINGS_PAGE = '/casino-ads-settings',
  TOURNAMENT_SETTINGS_PAGE = '/tournament-settings',
  MAIN_SCREEN_SETTINGS_PAGE = '/main-screen-settings',
  CASINO_SETTINGS_PAGE = '/casino-settings',
  PARTNER_SETTINGS_PAGE = '/partner-settings',
  USER_SETTINGS_PAGE = '/user-settings',
  USER_PROFILE_PAGE = '/user-profile/:userId',
  TOURNAMENTS_HISTORY_PAGE = '/tournaments-history',
  STREAMER_WHEEL_SETTINGS_PAGE = '/streamer-wheel-settings',
  PROMO_CODE_SETTINGS_PAGE = '/promo-code-settings',
  SUSPICIOUS_USERS_PAGE = '/suspicious-users',
  MODAL_SETTINGS_PAGE = '/modal-settings',
  TELEGRAM_BOT_SETTINGS_PAGE = '/telegram-bot-settings',
  DAILY_BONUSES_SETTINGS_PAGE = '/daily-bonuses-settings',
  REWARDS_HISTORY_PAGE = '/rewards-history',
  STORE_SETTINGS_PAGE = '/store-settings',
  VIDEO_SETTINGS_PAGE = '/video-settings',
  LEVEL_SETTINGS_PAGE = '/level-settings',
  LOTTERY_SETTINGS = '/lottery-settings',
  BET_SYSTEM_SETTINGS = '/bet-system-settings',
  PROVIDER_FREE_SPINS_SETTINGS_PAGE = '/provider-free-spins-settings',
  PROVIDER_SLOT_SETTINGS_PAGE = '/provider-slot-settings',
  VIP_SETTINGS_PAGE = '/vip-settings',
  CHEATER_SETTINGS_PAGE = '/cheater-settings',
  DISTRIBUTION_LINK_SETTINGS_PAGE = '/distribution-link-settings',
  DOMAIN_SETTINGS_PAGE = '/domain-settings',
  REFERRAL_REWARD_SETTINGS_PAGE = '/referral-reward-settings',
  TICKETS_PAGE = '/ticket-settings',
  USER_GUIDES_PAGE = '/user-guide-settings',
  ENTRY_REWARDS_PAGE = '/entry-reward-settings',
  TOURNAMENT_GROUP_PAGE = '/tournament-group-settings',
  MAILING_SETTINGS_PAGE = '/mailing-settings',
  BROADCAST_NOTIFICATIONS_PAGE = '/broadcast-notifications',
  REFERRAL_SYSTEM_V2_PAGE = '/referral-system-v2',
  FORBIDDEN = '/403',
}
